import type { SchemaDiffField } from '@core-engine/snapshots/schema-diff.js'

export interface RenameCandidate {
  before: string
  after: string
}

function levenshtein(a: string, b: string): number {
  const matrix = Array.from({ length: a.length + 1 }, () => new Array<number>(b.length + 1).fill(0))

  for (let i = 0; i <= a.length; i++) matrix[i]![0] = i
  for (let j = 0; j <= b.length; j++) matrix[0]![j] = j

  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1
      matrix[i]![j] = Math.min(
        matrix[i - 1]![j]! + 1,
        matrix[i]![j - 1]! + 1,
        matrix[i - 1]![j - 1]! + cost
      )
    }
  }

  return matrix[a.length]![b.length]!
}

export function detectStringRenameCandidates(
  removed: string[],
  added: string[]
): RenameCandidate[] {
  const candidates: RenameCandidate[] = []

  for (const before of removed) {
    const match = added.find((after) => levenshtein(before, after) <= 3)
    if (match) {
      candidates.push({ before, after: match })
    }
  }

  return candidates
}

export function detectRenameCandidates(
  removed: SchemaDiffField[],
  added: SchemaDiffField[]
): RenameCandidate[] {
  const candidates: RenameCandidate[] = []

  for (const before of removed) {
    const match = added.find(
      (after) => after.type === before.type && levenshtein(before.name, after.name) <= 3
    )
    if (match) {
      candidates.push({ before: before.name, after: match.name })
    }
  }

  return candidates
}
